import { render, staticRenderFns } from "./ModalAction.vue?vue&type=template&id=7ffb3243&scoped=true&"
import script from "./ModalAction.vue?vue&type=script&lang=ts&"
export * from "./ModalAction.vue?vue&type=script&lang=ts&"
import style0 from "./ModalAction.vue?vue&type=style&index=0&id=7ffb3243&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffb3243",
  null
  
)

export default component.exports